const SubscriptionDetails = ({subscriptionDetails = {}}) => {
	const pricing_amount = process.env.REACT_APP_STRIPE_MONTHLY_PRICING;
    return (
        <div className="mjs-dash-section mjs-dash-section-half">
            <div className="mjs-dash-sec-header"><h4>Subscription Details</h4></div>
            <div className="mjs-dash-inner-container">
                <div className="mjs-dash-row">
                    <span>Status</span>
                    <span>{subscriptionDetails.paused ? 'Cancelled' : (subscriptionDetails.status || '-')}</span>
                </div>
                <div className="mjs-dash-row">
                    <span>Monthly Total</span>
                    <span>${(Number(subscriptionDetails.amount || {pricing_amount})).toFixed(2)}</span>
                </div>
                <div className="mjs-dash-row">
                    <span>Yearly Total</span>
                    <span>${(Number(subscriptionDetails.amount || {pricing_amount}) * 12).toFixed(2)}</span>
                </div>
                <div className="mjs-dash-row">
                    <span>Created At</span>
                    <span>
                        {new Date(subscriptionDetails.createdAt).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "long",
                            year: "numeric"
                        })}
                    </span>
                </div>
                <div className="mjs-dash-row">
                    <span>Renewal Date </span>
                    <span>
                        {subscriptionDetails?.paused && <i title="Uncollectible" style={{color: "red"}} class="fa-solid fa-circle-exclamation"></i>}
                        {" "}
                        {subscriptionDetails.currentPeriodEnd
                            ? new Date(subscriptionDetails.currentPeriodEnd).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "long",
                                year: "numeric"
                            })
                            : "—"}
                    </span>

                </div>
            </div>
        </div>
    );
};

export default SubscriptionDetails;
